<template>
	<div style="display: grid; gap: 30px; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr); align-items: start">
		<DashboardItem title="Top">
			<template v-slot:main>
				<Table
					:head="tableHeader"
					:stickyHead="true"
					:size="tableSizes">
					<TransitionGroup name="list">
						<TableRow
							:size="tableSizes"
							:key="item.driver_id"
							v-for="item of listOfDrivers.best">
							<div class="dispatcher-name">
								<a
									href=""
									@click.prevent=""
									><span style="text-transform: capitalize">{{ item.driver_full_name }}</span></a
								>
							</div>
							<div>
								<strong>{{ item.total_miles.toFixed(0) }}</strong>
							</div>
							<div>
								<strong>{{ CURRENCY.format(item.total_load_pay) }}</strong>
							</div>
						</TableRow>
					</TransitionGroup>
				</Table>
			</template>
		</DashboardItem>

		<DashboardItem title="Underdogs">
			<template v-slot:main>
				<Table
					:head="tableHeader"
					:stickyHead="true"
					:size="tableSizes">
					<TransitionGroup name="list">
						<TableRow
							:size="tableSizes"
							:key="item.driver_id"
							v-for="item of listOfDrivers.worst">
							<div class="dispatcher-name">
								<a
									href=""
									@click.prevent=""
									><span style="text-transform: capitalize">{{ item.driver_full_name }}</span></a
								>
							</div>
							<div>
								<strong>{{ item.total_miles.toFixed(0) }}</strong>
							</div>
							<div>
								<strong>{{ CURRENCY.format(item.total_load_pay) }}</strong>
							</div>
						</TableRow>
					</TransitionGroup>
				</Table>
			</template>
		</DashboardItem>
	</div>
</template>

<script>
import DashboardItem from "../DashboardItem.vue";

export default {
	components: {
		DashboardItem,
	},
	props: ["stats"],
	computed: {
		listOfDrivers() {
			try {
				const arr = JSON.parse(JSON.stringify(this.stats.drivers)).sort((a, b) => b.total_miles - a.total_miles);

				const middleIndex = Math.floor(arr.length / 2);
				const firstHalf = arr.slice(0, middleIndex);

				const secondHalf = arr.slice(middleIndex);
				secondHalf.sort((a, b) => a.total_miles - b.total_miles);

				return { best: firstHalf.slice(0, 10), worst: secondHalf.slice(0, 10) };
			} catch (e) {
				return { best: [], worst: [] };
			}
		},
		tableHeader() {
			return [{ name: "Driver" }, { name: "Total Miles" }, { name: "Driver Gross" }];
		},
		tableSizes() {
			return ["minmax(0, 1fr)", "minmax(100px, 150px)", "minmax(100px, 150px)"];
		},
	},
};
</script>

<style lang="scss" scoped></style>
